export default {
  system: {
    user: 'User',
    level: 'Antas',
    earnPerTap: 'Kitain sa bawat tap',
    coinsToLevelUp: 'Barya para mag-level up',
    profitPerHour: 'Kita bawat oras',
    coming1: 'May kakaibang bagay',
    coming2: 'na darating dito sa lalong madaling panahon...',
    close: 'Isara',
    friends: 'Mga Kaibigan',
    continue: 'Magpatuloy',
  },
  settings: {
    chooseNetwork: 'Pumili ng network',
    chooseLanguage: 'Pumili ng wika',
  },
  popup_CheckTask: {
    join: 'Sumali',
    check: 'Suriin',
    taskIsNotCompleted: 'Hindi pa nakumpleto ang gawain',
  },
  popup_levelUp: {
    levelUp: 'Level up!',
    multiTap: 'Multitap',
    energyLimit: 'Limitasyon ng enerhiya',
  },
  popup_BalanceUp: {
    balanceUp: 'May update sa balanse!',
    balanceDiffSinceLast: 'Ang iyong gantimpala',
  },
  popup_BalanceTip: {
    tip: 'Palakasin ang iyong kita',
    message: 'I-tap ang Mine menu para bumili ng mga upgrade para sa iyong network',
    description: 'Kumita kahit offline hanggang 3 oras',
  },
  popup_Bored: {
    header: 'Nababagot ang palaka!',
    message: 'Maglaro sa palaka.',
    description: 'Kung hindi pinaglalaruan ang palaka ng 3 oras, titigil ang kita',
  },
  popup_Hungry: {
    header: 'Nagugutom ang palaka!',
    message: 'Pakainin ang palaka.',
    description: 'Mas maraming kaibigan, mas maraming baryang makukuha sa bawat pagpapakain',
  },
  menu: {
    network: 'Network',
    mine: 'Mine',
    earn: 'Kumita',
    food: 'Pagkain',
  },
  tap: {
    bored: 'Bored',
    fun: 'Masaya',
  },
  mineMenu: {
    activities: 'Mga Aktibidad',
    investments: 'Mga Pamumuhunan',
    web3: 'WEB3',
    achievements: 'Mga Tagumpay',
  },
  leaderboard: {
    from: 'mula sa',
    beTheFirst: 'Maging una!',
  },
  mine: {
    joinOurTG1: 'Sumali sa aming Telegram channel,',
    joinOurTG2: 'para ma-unlock!',
    unlock: 'I-unlock',
  },
  friends: {
    inviteFriends: 'Mag-imbita ng mga kaibigan!',
    receiveBonuses: 'Ikaw at ang iyong kaibigan ay makakatanggap ng mga bonus',
    inviteFriend: 'Mag-imbita ng kaibigan',
    withTelegramPremium: 'na may Telegram Premium',
    forYouAndYourFriend: 'para sa iyo at sa iyong kaibigan',
    moreBonuses: 'Mas maraming bonus',
    listOfYourFriends: 'Listahan ng iyong mga kaibigan',
    linkCopied: 'Nakopya na ang link ng imbitasyon sa iyong clipboard!',
    playWithMe:
      'Sumali sa akin at maglaro para kumita ng mga token sa pamamagitan ng airdrop!\n' +
      '💰 Kunin ang iyong regalo! +3000 barya para sa mga bagong sali\n' +
      '🚀 May Telegram Premium ka ba? Makakuha ng +5000 barya!\n',
  },
  earn: {
    moreCoins: 'Kumita ng mas maraming barya!',
    dailyTasks: 'Mga pang-araw-araw na gawain',
    dailyReward: 'Pang-araw-araw na gantimpala',
    tasksList: 'Listahan ng mga gawain',
    joinOurTG: 'Sumali sa aming Telegram channel',
    followOurX: 'Sundan ang aming X account',
    yourAd: 'Pwedeng ilagay dito ang iyong advertisement',
    connect: 'Makipag-ugnayan sa admin ng aming Telegram channel',
  },
  food: {
    hungry: 'Gutom',
    full: 'Busog',
    frogIsFull: 'Busog na ang palaka',
    feed: 'Pakainin',
    bonus: 'Bonus',
    satiety: 'Kasiyahan',
    hours: 'oras',
  },
  toast: {
    buyCard: {
      title: 'Tagumpay na Na-unlock!',
      subtitle: 'Oras na para iakay ang iyong imperyo ng palaka sa kadakilaan 👑',
    },
    feedFrog: {
      title: 'Masaya ang Palaka!',
      subtitle: 'Magaling! Pakainin ang iyong alaga para mapanatili ang mga ngiti 🍽️',
    },
  },
};
